class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));  
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }

      // const price_elements = document.querySelectorAll('#price-to-display');
      // price_elements.forEach((el) => {
      //   const qty_x_price = ( event.cartData.presentment_price * event.cartData.quantity);
      //   const qty_x_price_formatted = qty_x_price.toLocaleString("en-IN");
      //   el.innerHTML = event.cartData.quantity ? qty_x_price_formatted : el.dataset.price;
      // });

      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);

    console.log('[0] value', input.value)
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }
  async onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          const sourceCartDrawer = html.querySelector('cart-drawer');
          const isCartEmpty = sourceCartDrawer ? sourceCartDrawer.classList.contains('is-empty') : false;

          const cartDrawerWrapper = document.querySelector('cart-drawer');
          if (cartDrawerWrapper) {
            cartDrawerWrapper.classList.toggle('is-empty', isCartEmpty);
          }

          const selector = '.drawer__inner'; 
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);

          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);

            if (isCartEmpty) {
              const emptyCartScriptSrc = document.querySelector('script[src*="cart-empty.js"]')?.src;
              if (emptyCartScriptSrc) {
                loadScript(emptyCartScriptSrc);
              } else {
                console.warn('Could not find cart-empty.js to reload.');
              }
            }
          } else {
            console.warn('Could not find .drawer__inner, falling back to partial replace.');
            const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
            for (const selector of selectors) {
              const targetElementFallback = document.querySelector(selector);
              const sourceElementFallback = html.querySelector(selector);
              if (targetElementFallback && sourceElementFallback) {
                targetElementFallback.replaceWith(sourceElementFallback);
              }
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
    }
  }

  // async onCartUpdate() {
  //   if (this.tagName === 'CART-DRAWER-ITEMS') {
  //     return fetch(`${routes.cart_url}?section_id=cart-drawer`)
  //       .then((response) => response.text())
  //       .then((responseText) => {
  //         const html = new DOMParser().parseFromString(responseText, 'text/html');
  //         const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
  //         for (const selector of selectors) {
  //           const targetElement = document.querySelector(selector);
  //           const sourceElement = html.querySelector(selector);
  //           if (targetElement && sourceElement) {
  //             targetElement.replaceWith(sourceElement);
  //           }
  //         }
  //       })
  //       .catch((e) => {
  //         console.error(e);
  //       });
  //   } else {
  //     return fetch(`${routes.cart_url}?section_id=main-cart-items`)
  //       .then((response) => response.text())
  //       .then((responseText) => {
  //         const html = new DOMParser().parseFromString(responseText, 'text/html');
  //         const sourceQty = html.querySelector('cart-items');
  //         this.innerHTML = sourceQty.innerHTML;
  //       })
  //       .catch((e) => {
  //         console.error(e);
  //       });
  //   }
  // }

  getSectionsToRender() {

    // const sections = ['cart-icon-bubble'];

    // if (this.tagName === 'CART-DRAWER-ITEMS') {
    //   sections.push('cart-drawer');
    // } else {
    //   // Main cart page
    //   const mainCartItemsEl = document.getElementById('main-cart-items');
    //   if (mainCartItemsEl) sections.push(mainCartItemsEl.dataset.id);

    //   const mainCartFooterEl = document.getElementById('main-cart-footer');
    //   if (mainCartFooterEl) sections.push(mainCartFooterEl.dataset.id);
    // }
    
    // return [...new Set(sections)];
    
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';
    const cartPerformanceUpdateMarker = CartPerformance.createStartingMarker(`${eventTarget}:user-action`);

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        
         CartPerformance.measure(`${eventTarget}:paint-updated-sections`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          const cartIsEmpty = parsedState.item_count === 0;
          
          this.classList.toggle('is-empty', cartIsEmpty);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', cartIsEmpty);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', cartIsEmpty);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });

          if (cartIsEmpty && typeof window.initEmptyCartCarousel === 'function') {
            window.initEmptyCartCarousel();
          }

          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        CartPerformance.measureFromMarker(`${eventTarget}:user-action`, cartPerformanceUpdateMarker);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError && message) {
      const cartItemError = lineItemError.querySelector('.cart-item__error-text');
      cartItemError.textContent = message;
      lineItemError.style.display = message ? 'block' : 'none';
    }

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}


document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('cart-drawer');

  if (!cartDrawer) return; // Safety check

  cartDrawer.addEventListener('submit', async (event) => {
    const form = event.target;
    if (form.getAttribute('action') !== '/cart/add' || !form.closest('.empty-cart__carousel-container')) {
      return;
    }

    event.preventDefault();

    const submitButton = form.querySelector('[type="submit"]');

    if (submitButton) {
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.classList.add('loading');
      const addingText = submitButton.dataset.addingText || 'Adding...';
      const buttonTextSpan = submitButton.querySelector('.empty-cart-add-to-cart-text');
      if (buttonTextSpan) {
        buttonTextSpan.textContent = addingText;
      } else {
        submitButton.innerHTML = addingText;
      }
    }

    const formData = new FormData(form);

    try {
      const response = await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.description || 'An error occurred. Please try again.');
      }

      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-empty-add-to-cart', cartData: responseData, variantId: formData.get('id') });

    } catch (error) {
      console.error(error);
      if (submitButton) {
        submitButton.removeAttribute('disabled');
        submitButton.classList.remove('loading');
        
        const originalText = submitButton.dataset.originalText || 'Add to cart';
        const buttonTextSpan = submitButton.querySelector('.empty-cart-add-to-cart-text');

        if (buttonTextSpan) {
            buttonTextSpan.textContent = 'Error!';
            setTimeout(() => { buttonTextSpan.textContent = originalText; }, 3000);
        } else {
            submitButton.innerHTML = 'Error!';
            setTimeout(() => { submitButton.innerHTML = originalText; }, 3000);
        }
      }
    }
  });


  // Cart Upsell Click Handler (Add Button + Opener)
  async function addToCart(addButton, variantId, addText, addingText, addedText) {
    try {
      const response = await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      const responseData = await response.json();
      if (!response.ok) {
        throw new Error(responseData.description || 'An error occurred.');
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { 
          source: 'cart-upsell-add', 
          cartData: responseData,
          variantId: variantId 
        });
      } else {
        console.error('publish or PUB_SUB_EVENTS not defined. Reloading.');
        window.location.reload(); // Fallback
      }
      
      addButton.classList.remove('loading');
      addButton.classList.add('is-added');
      addButton.textContent = addedText;

    } catch (error) {
      console.error('Error adding upsell item:', error);
      addButton.disabled = false;
      addButton.classList.remove('loading');
      addButton.textContent = 'Error!';
      setTimeout(() => {
        addButton.textContent = addText;
      }, 3000);
    }
  }

  cartDrawer.addEventListener('click', async (event) => {
    const addButton = event.target.closest('.js-upsell-add-button');
    if (addButton && !addButton.disabled) {
      const variantId = addButton.dataset.variantId;
      const addText = addButton.dataset.addText || 'Add';
      const addingText = addButton.dataset.addingText || 'Adding...';
      const addedText = addButton.dataset.addedText || 'Added';
      
      addButton.disabled = true;
      addButton.classList.add('loading');
      addButton.textContent = addingText;

      addToCart(addButton, variantId, addText, addingText, addedText);

      return;
    }

    const openerButton = event.target.closest('.cart-upsell-item__opener');
    if (openerButton) {
      event.preventDefault();

      const cartUpsellInst = new CartUpsellModal();
      
      const productHandle = openerButton.dataset.productHandle;
      const variantId = openerButton.dataset.variantId;
      const showDiscount = openerButton.dataset.showDiscount === 'true';
      const discountAmount = parseFloat(openerButton.dataset.discountAmount || 0);
      const discountThreshold = parseFloat(openerButton.dataset.discountThreshold || 0);
      const cartTotal = parseFloat(openerButton.dataset.cartTotal || 0);

      // console.log('I am clicked!');
      // console.log('Opening details for product:', productHandle);

      cartUpsellInst.open(productHandle, variantId, showDiscount, discountAmount, discountThreshold, cartTotal);

      return;
    }
  });
});